import { render, staticRenderFns } from "./testimonial-section.vue?vue&type=template&id=37f94b48&scoped=true&"
import script from "./testimonial-section.vue?vue&type=script&lang=js&"
export * from "./testimonial-section.vue?vue&type=script&lang=js&"
import style0 from "./testimonial-section.vue?vue&type=style&index=0&id=37f94b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f94b48",
  null
  
)

export default component.exports